import { observer } from "mobx-react-lite"
import Layout from "../../components/layout/Layout"
import { useStore } from "../../stores/root-store-context";
import { Button, Flex, Form, FormProps, Input, Modal, Popconfirm, Select, Image, Spin, Table, TableProps, Tag, Typography, message, AutoComplete, Tabs, TabsProps, Upload, GetProp, Tooltip } from "antd";
import { Key, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ResourceItem, ResourceType } from "../../stores/ResourcesStore";
import { RcFile, UploadChangeParam, UploadFile, UploadProps } from "antd/es/upload";

const Search = Input.Search;


const DeleteAccount = observer(() => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const { applicationStore, resourceStore, employeesStore } = useStore();
    const [searchText, setSearchText] = useState("");

    const [currentFileList, setCurrentFileList] = useState<UploadFile[]>([]);


    const onDelete: FormProps<ResourceItem>['onFinish'] = async (item: ResourceItem) => {
        message.open({
            type: 'loading',
            content: t("Deleting"),
            key: 'Deleting'
        });
        // todo add delete account api
    };


    return (
        <Layout headerStyle={1} footerStyle={2} breadcrumbTitle={`${t("DeleteUser")}`}>
            <div className="container" style={{ margin: "20px auto" }}>
                <Form form={form} onFinish={onDelete} labelCol={{ span: 24 }}>
                    <Form.Item<ResourceItem> label={t("Email")} name="title" style={{ width: "100%" }} rules={[{ required: true }]} >
                        <Input placeholder="Email" />
                    </Form.Item>
                    <Form.Item<ResourceItem> label={t("Password")} name="title" style={{ width: "100%" }} rules={[{ required: true }]} >
                        <Input placeholder="Password" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" className="theme-btn" htmlType="submit" style={{ height: 65, float: "right" }}>
                            {t("Delete")}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </Layout>
    )
})
export default DeleteAccount;